import { v4 as uuidv4 } from 'uuid';

import type ModuleButtonsType from 'app/main/modules/components/ModuleButtonsType';
import { showDeleteDialog } from 'app/main/components';
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';

function parseRows(rows?: any[]) {
	return rows?.map(row => ({ ...row, inrw_uid: uuidv4() }));
}

function parseDeadlines(deadlines?: any[]) {
	return deadlines?.map(deadline => ({ ...deadline, indl_uid: uuidv4() }));
}

const buttons: ModuleButtonsType = {
	view: {
		itemButtons: [
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'invoices'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'invoices',
							updateRefresh,
							isUpdate: true,
							maxDialogWidth: 'lg',
							model
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_ADD_COPY',
				icon: 'content-copy',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'invoices'),
				action: ({ dispatch, updateRefresh, model, t }) => {
					dispatch(
						showFastAddDialog({
							module: 'invoices',
							updateRefresh,
							maxDialogWidth: 'lg',
							model: {
								...model,
								invc_title: t('MODULE_INVOICES_NAME_SINGULAR').toLocaleUpperCase(),
								invc_rows: parseRows(model.invc_rows),
								invc_deadlines: parseDeadlines(model.invc_deadlines)
							}
						})
					);
				}
			},
			{
				name: 'VIEW_ITEM_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'invoices'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showDeleteDialog({
							module: 'invoices',
							id: model.invc_uid,
							title: model.invc_title,
							updateRefresh
						})
					)
			}
		],
		headerButtons: [
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				hidden: ({ authorizer }) => authorizer.cannot('create', 'invoices'),
				action: ({ dispatch, updateRefresh }) =>
					dispatch(showFastAddDialog({ module: 'invoices', updateRefresh, maxDialogWidth: 'lg' }))
			}
		]
	}
};

export default buttons;
